import React from 'react';
import classNames from 'classnames';

import useStyles from './useStyles';

export type SurveyLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  /** Required href */
  href: string;
  /** Changes behaviour of the textDecoration for hover/focus. */
  underline?: 'always' | 'never' | 'inverse' | 'auto';
};

/**
 * A Survey-Styled Link
 */
function SurveyLink({ className, underline = 'auto', children, ...props }: SurveyLinkProps): React.ReactElement {
  const styles = useStyles({ underline });
  return (
    <a className={classNames(styles.surveyAnchor, className)} {...props}>
      {children}
    </a>
  );
}

export default SurveyLink;
